import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { UserState } from 'src/reducers/user/model';

const initialState: UserState = {
  publicProfile: null,
  campaignList: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updatePublicProfile: (state, action: PayloadAction<UserState['publicProfile']>) => {
      state.publicProfile = action.payload;
    },
    updateCampaignList: (state, action: PayloadAction<UserState['campaignList']>) => {
      state.campaignList = action.payload;
    },
    resetUserState: () => {
      return initialState;
    },
  },
});

export const { updatePublicProfile, updateCampaignList, resetUserState } = userSlice.actions;
export default userSlice.reducer;
